import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router";
import { gtmJoinClick } from "../../utilities/gtm";
import { getString, isLoggedInWithoutRole } from "../../utilities";
import { userRoles } from "../../config";
import { routeCodes } from "../../config/routes";
import { isLoggedInSelector } from "../../redux/slices/loginSlice";
import { mpSubCTASelect } from "../../utilities/mixpanel";

export default function PremiumPlanet() {
  const location = useLocation();
  const isLoggedIn = useSelector(isLoggedInSelector);

  const premMessage = !isLoggedIn ? getString("join.5") : getString("upgrade.title.0");
  const premRoute = !isLoggedIn ? routeCodes.SUBSCRIBE : routeCodes.MANAGE;

  if (isLoggedInWithoutRole(userRoles.free)) {
    return null;
  }

  return (
    <Link
      className="home-planet premium"
      to={premRoute}
      onClick={() => {
        if (!isLoggedIn) {
          gtmJoinClick("/", "home-planet-button");
          mpSubCTASelect("general", "home-planet", premMessage, location.pathname);
        }
      }}
    >
      <span>{premMessage}</span>
    </Link>
  );
}
